var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-demo",
      attrs: {
        "default-active": "1-4-1",
        collapse: _vm.isCollapse,
        "background-color": "#545c64",
        "unique-opened": true,
        "text-color": "#fff",
        "active-text-color": "#ffd04b",
      },
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.isCollapse ? "后台" : "后台管理系统"))]),
      _vm._l(_vm.menuData, function (route) {
        return _c("sidebarItem", {
          key: route.path || route.name,
          attrs: { item: route, "base-path": route.path || "" },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }